import React, { TextareaHTMLAttributes } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name?: string;
  value: string;
  label?: string;
  error?: string | null | undefined;
  className?: string;
  labelClassName?: string;
  textAreaClassName?: string;
  placeholder?: string;
  maxLength?: number;
  id?: string;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const TextArea: React.FC<TextAreaProps> = ({
  name,
  value,
  placeholder,
  error,
  label,
  maxLength,
  className = '',
  labelClassName = '',
  textAreaClassName = '',
  disabled,
  id,
  onBlur,
  onChange,
}) => (
  <div className={`relative space-y-1.5 ${className}`}>
    {label && (
      <label
        htmlFor={id || name}
        className={`block text-gray-500 text-base font-dmsans font-regular ${labelClassName}`}
      >
        {label}
      </label>
    )}
    <textarea
      id={id}
      name={name}
      value={value}
      placeholder={placeholder ?? 'Digite aqui'}
      maxLength={maxLength}
      disabled={disabled}
      onBlur={onBlur}
      onChange={onChange}
      aria-invalid={error ? 'true' : 'false'}
      className={`relative appearance-none rounded w-full text-input text-base leading-tight focus:outline-none ${
        error ? 'border-red-500' : 'border-none'
      } ${textAreaClassName}`}
      rows={10} // padrão para o número de linhas
    />
    {error && <p className="text-red-500 text-xs">{error}</p>}
  </div>
);

export default TextArea;
